import React from 'react';
import { useUser } from '../contexts/UserContext';
import { Dashboard } from './Dashboard';
import LandingPage from './LandingPage';

/**
 * HomePage - Conditionally renders landing page or dashboard based on auth status
 * 
 * This component:
 * - Shows the landing page for unauthenticated users
 * - Shows the dashboard for authenticated users
 * - Provides seamless transition between states
 */
export const HomePage: React.FC = () => {
  const { currentUser } = useUser();

  return currentUser ? <Dashboard /> : <LandingPage />;
};

export default HomePage;